import React from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

const HorizontalRuler = props => {
  const classes = useStyles(props)
  const { className } = props
  return (
    <hr className={clsx(classes.ruler, className)}></hr>
  )
}

const useStyles = makeStyles((theme) => ({
  ruler: {
    marginTop: 30,
    color: theme.borderColor,
    marginBottom: 30,
  },
}))

export default HorizontalRuler
